<template lang="pug">
  .ativo_card
    v-card.ativo-card(
      :style="ativo.consistenciaTotal ? 'border: 0.1vh solid #CCEDFF': 'border: 0.1vh solid #F86A6A'"
    )
      v-container.pa-1(fluid)
        v-layout.pa-3(column)
          span.ativo-card-title {{ ativo.titulo }}
          v-layout(
            row
          )
            v-flex(xs6)
              v-img.ativo-card-image(
                :src="ativo.imagem ? ativo.imagem : defaultImage"
                :lazy-src="defaultImage"
                aspect-ratio="1"
              )
            v-flex(xs6)
              v-container(fill-height fluid).py-2.pr-0.pl-2
                v-layout(justify-space-between column fill-height)
                  dispositivo(
                    icon="signal_cellular_alt"
                    label="Internet"
                    :date="ativo.dispositivos.comunicacao.consultadoEm"
                    :status="ativo.dispositivos.comunicacao.enabled"
                  )
                  dispositivo(
                    icon="opacity"
                    label="Água e Gás"
                    :date="ativo.dispositivos.agua_gas.consultadoEm"
                    :status="ativo.dispositivos.agua_gas.enabled"
                  )
                  dispositivo(
                    icon="flash_on"
                    label="Energia"
                    :date="ativo.dispositivos.energia.consultadoEm"
                    :status="ativo.dispositivos.energia.enabled"
                  )
                  dispositivo(
                    icon="meeting_room"
                    label="Acesso"
                    :date="ativo.dispositivos.acesso.consultadoEm"
                    :status="ativo.dispositivos.acesso.enabled"
                  )
          v-divider.my-2(color="#E0E0E0")
          consistencia.mt-1(
            :acesso="ativo.detalhesDeAcesso"
            :loading="loadingSync"
            @click="syncDadosConsistencia($event)"
            @generate-period-code="generatePeriodCode()"
          )
      v-card-actions.bottom-card(
        :style="cardActionStyle"
      )
        span.status-title(
          :style="statusStyle"
        ) Status do imóvel:
        span.status-text(
          :style="statusStyle"
        ) {{ statusMessage }}
</template>

<script>
import DashboardService from '@/services/DashboardService';
import Dispositivo from '@/app/Dashboard/components/Dispositivo';
import Consistencia from '@/app/Dashboard/components/Consistencia';
import grayImage from '@/assets/grayImage.jpg';

export default {
  name: 'AtivoCard',
  props: {
    ativo: {
      type: Object,
      default() {
        return {};
      },
    },
    filialId: {
      type: String,
      default: '',
    },
  },
  components: {
    Dispositivo,
    Consistencia,
  },
  data() {
    return {
      defaultImage: grayImage,
      loadingSync: false,
    };
  },
  computed: {
    statusMessage() {
      return this.ativo.consistenciaTotal ? 'OK!' : 'Falha na comunicação';
    },
    cardActionStyle() {
      return this.ativo.consistenciaTotal ? 'border-top: 0.1vh solid #CCEDFF' : 'border-top: 0.1vh solid #F86A6A; background: #FFE3E3 !important';
    },
    statusStyle() {
      return this.ativo.consistenciaTotal ? 'color: #2CB5FF' : 'color: #CF1124';
    },
  },
  methods: {
    generatePeriodCode() {
      DashboardService.generatePeriodCode(this.ativo.imovelId)
        .then(() => {
          this.$swal({
            title: 'Código gerado com sucesso',
            type: 'success',
            confirmButtonColor: '#0277BD',
            confirmButtonText: 'Ok',
          });
        })
        .catch((e) => {
          const { data } = e.response;
          const { message, status } = data;
          if (status === 403) {
            this.alertErrorBlock('Sem permissão');
          } else {
            this.alertErrorBlock(message);
          }
        })
        .finally(() => {
          this.loadingSync = false;
        });
    },
    syncDadosConsistencia() {
      this.loadingSync = true;
      DashboardService
        .patchConsistencia(this.filialId, this.ativo.imovelId)
        .then(({ data }) => {
          this.ativo.consistenciaTotal = data.consistenciaTotal;
          this.ativo.detalhesDeAcesso = data.detalhesDeAcesso;
          this.ativo.dispositivos = data.dispositivos;
          this.ativo.imagem = data.imagem;
          this.ativo.imovelId = data.imovelId;
          this.ativo.titulo = data.titulo;
          this.loadingSync = false;
        })
        .catch(({ response }) => {
          const { data } = response;
          const { message } = data;
          this.alertErrorBlock(message);
          this.loadingSync = false;
        });
    },
    alertErrorBlock(errorMessage) {
      this.$swal({
        title: errorMessage,
        type: 'error',
        confirmButtonColor: '#0277BD',
        confirmButtonText: 'Ok',
      });
    },
  },
};
</script>

<style lang="sass">
  .ativo-card
    background-color: #FFFFFF !important
    border-radius: 0.4vh
  .ativo-card-image
    max-height: 17vh
    border-radius: 0.5vh
  .ativo-card-title
    font-weight: 500
    font-size: 1.8vh
    line-height: 2.1vh
    color: #363636
  .bottom-card
    background: #F7FAFD !important
    padding: 0.8vh 1.6vh !important
  .status-title
    font-size: 1.8vh
    font-weight: bold
    color: #2CB5FF
  .status-text
    margin-left: 0.2vh
    font-size: 1.8vh
    color: #2CB5FF
</style>



// WEBPACK FOOTER //
// src/app/Dashboard/components/AtivoCard.vue